var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBlueUavIconSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.035 4.803a2.068 2.068 0 1 1 .658-.658l.793.793a3.41 3.41 0 0 0 4.823 0l1.035-1.035a2.068 2.068 0 1 1 .55.619l-.854.855a3.41 3.41 0 0 0 0 4.822l.961.962a2.068 2.068 0 1 1-.657.658l-.816-.816a3.41 3.41 0 0 0-4.822 0L4.639 12.07a2.068 2.068 0 1 1-.56-.61l.896-.894a3.41 3.41 0 0 0 0-4.823l-.94-.94Zm-.455-.456a1.447 1.447 0 1 1 .658-.657l-.317-.317a1.033 1.033 0 1 0-.657.658l.316.316Zm.054 7.56a1.447 1.447 0 1 0 .547.62l-.32.321a1.033 1.033 0 1 1-.53-.639l.303-.303Zm8.165.367a1.447 1.447 0 1 0 .658-.658l.316.317a1.033 1.033 0 1 1-.658.657l-.316-.316Zm.54-8.197a1.447 1.447 0 1 0-.534-.635l.325-.325a1.033 1.033 0 1 1 .51.659l-.3.3Z",
  fill: "#00BCDD"
})));

export { SvgBlueUavIconSmall as ReactComponent };
export default __webpack_public_path__ + "aa6de9442ba1d07759dd890ab85362e4.svg";